export const titleize = (string: string | undefined | null) =>
  !string
    ? ''
    : string
        .toLowerCase()
        .replace(/_/g, ' ')
        .replace(/(?:^|\s|-)\S/g, x => x.toUpperCase());
